import { render, staticRenderFns } from "./DossierUpload.vue?vue&type=template&id=385d3049&scoped=true&"
import script from "./DossierUpload.vue?vue&type=script&lang=js&"
export * from "./DossierUpload.vue?vue&type=script&lang=js&"
import style0 from "./DossierUpload.vue?vue&type=style&index=0&id=385d3049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d3049",
  null
  
)

export default component.exports